// ТЗ 0088 — раздел «Маркетинг». Все имена с префиксом `marketing` /
// `MARKETING_` / `IMarketing`: барабан `core/hooks` собирает модули через
// `export *`, и одноимённое (`DRILLDOWN_NEXT` опросов) столкнулось бы.
export * from './types';
export * from './marketingModel';
export * from './marketingSearchModel';
export * from './marketingIntelModel';
export * from './marketingInspectorModel';
export * from './marketingMatrixModel';
export * from './marketingApi';
export * from './useMarketingPermissions';
export * from './useMarketingDeepLink';
export * from './useMarketingReports';
export * from './useMarketingInspector';
export * from './useMarketingMutations';
export * from './useMarketingRecalcWatch';
